import { MenuContentItem } from '@frontend/vanilla/core';

export interface NavigationStackParameters {
    /**
     * The initial URL where the user entered.
     * Useful in cases where the entry URL differs from the rootUrl (e.g., due to auto-redirects).
     */
    userEntryUrl?: string;
    /**
     * If true, this item handles its own click events.
     * When enabled, the stack service will not process bottom navigation clicks.
     * Useful for complex items (e.g., "MyBets").
     */
    useCustomClickHandler: boolean;
    /**
     * If true, the active stack can also be activated via user navigation.
     * By default, stacks are only activated through bottom navigation clicks or browser `popstate` navigation.
     */
    canBeActivatedByNav: boolean;
    /**
     * In cases where need define stack by current url, but can't use root url
     * Name is the same as for vanilla highlighting
     */
    highlightUrlPattern?: string;
}

export function getNavigationStackParameters(menuItem: MenuContentItem): NavigationStackParameters {
    return {
        canBeActivatedByNav: menuItem.parameters['stack-canBeActivatedByNav'] === 'true',
        useCustomClickHandler: menuItem.parameters['stack-useCustomClickHandler'] === 'true',
        userEntryUrl: menuItem.parameters['stack-userEntryUrl'],
        highlightUrlPattern: menuItem.parameters['highlight-url-pattern'],
    };
}
